
import { DmShareds } from 'saiten-base'

export default class DmService {

  static async upload_field_names(params: any = null) {
    const res = await DmShareds.Http.post(`./api/dm/sheets/upload_field_names`, params);
    return res.data;
  }

  static async sheet_fields(id: any, params: any = null) {
    const res = await DmShareds.Http.get(`./api/dm/sheets/${id}/fields`, {params: params});
    return res.data;
  }

  static async position_config(id: any, params: any = null) {
    const res = await DmShareds.Http.post(`./api/dm/sheets/${id}/position_config`, params);
    return res.data;
  }

  static async detect_page_rim(id: any, page: any, params: any = null) {
    const res = await DmShareds.Http.post(`./api/dm/sheets/${id}/detect_rim/${page}`, params);
    return res.data;
  }

  static async correct_image(id: any, params: any = null) {
    const res = await DmShareds.Http.get(`./api/dm/sheet_fields/${id}/correct_image`, {params: params});
    return res.data;
  }

  static async progress_search(params: any = null) {
    const res = await DmShareds.Http.get(`./api/dm/progress`, {params: params});
    return res.data;
  }

  static async sheet_activities_present(params: any = null) {
    const res = await DmShareds.Http.get(`./api/dm/sheet_activities/present`, {params: params});
    return res.data;
  }

  static async image_name(id: any, params: any = null) {
    const res = await DmShareds.Http.get(`./api/dm/sheet_activities/${id}/image/name`, {params: params});
    return res.data;
  }

  static async begin_saiten(id: any, params: any = null) {
    const res = await DmShareds.Http.get(`./api/dm/sheet_activities/${id}/begin_saiten`, {params: params});
    return res.data;
  }

  static async saiten_save(id: any, params: any = null) {
    const res = await DmShareds.Http.post(`./api/dm/sheet_activities/${id}/saiten_save`, params);
    return res.data;
  }

  static async reject_sheet_activity(id: any, params: any = null) {
    const res = await DmShareds.Http.post(`./api/dm/sheet_activities/${id}/reject`, params);
    return res.data;
  }

  static async saiten_tasks(params: any = null) {
    const res = await DmShareds.Http.get(`./api/dm/saiten/tasks`, {params: params});
    return res.data;
  }

  static async saiten_sheet_info(sheet_activity_id: any, params: any = null) {
    const res = await DmShareds.Http.get(`./api/dm/saiten/sheet/${sheet_activity_id}`, {params: params});
    return res.data;
  }

  static async image(id: any, params: any = null) {
    const res = await DmShareds.Http.get(`./api/dm/field_activities/${id}/image`, {params: params});
    return res.data;
  }

  static async saiten_sheets(id: any, params: any = null) {
    const res = await DmShareds.Http.get(`./api/dm/sheet_processes/${id}/saiten_sheets`, {params: params});
    return res.data;
  }

  static async saiten_pieces_list(id: any, params: any = null) {
    const res = await DmShareds.Http.get(`./api/dm/sheet_processes/${id}/saiten_pieces_list`, {params: params});
    return res.data;
  }

  static async imaging(id: any, params: any = null) {
    const res = await DmShareds.Http.get(`./api/dm/sheet_processes/${id}/imaging`, {params: params});
    return res.data;
  }

  static async ocr_status(id: any, params: any = null) {
    const res = await DmShareds.Http.get(`./api/dm/sheet_processes/${id}/ocr_status`, {params: params});
    return res.data;
  }

  static async delete_sheet_stamp(id: any, params: any = null) {
    const res = await DmShareds.Http.delete(`./api/dm/sheet_stamps/${id}`, params);
    return res.data;
  }

  static async delete_field_stamp(id: any, params: any = null) {
    const res = await DmShareds.Http.delete(`./api/dm/field_stamps/${id}`, params);
    return res.data;
  }

  static async assign_search(params: any = null) {
    const res = await DmShareds.Http.get(`./api/dm/assign/search`, {params: params});
    return res.data;
  }

  static async assign_exec(params: any = null) {
    const res = await DmShareds.Http.post(`./api/dm/assign/exec`, params);
    return res.data;
  }

  static async consts(params: any = null) {
    const res = await DmShareds.Http.get(`./api/dm/consts`, {params: params});
    return res.data;
  }

  static async log_debug(params: any = null) {
    const res = await DmShareds.Http.post(`./api/dm/log/debug`, params);
    return res.data;
  }

  static async log_info(params: any = null) {
    const res = await DmShareds.Http.post(`./api/dm/log/info`, params);
    return res.data;
  }

  static async log_warn(params: any = null) {
    const res = await DmShareds.Http.post(`./api/dm/log/warn`, params);
    return res.data;
  }

  static async log_error(params: any = null) {
    const res = await DmShareds.Http.post(`./api/dm/log/error`, params);
    return res.data;
  }

  static async students(params: any = null) {
    const res = await DmShareds.Http.get(`./api/dm/students`, {params: params});
    return res.data;
  }

  static async new_student(params: any = null) {
    const res = await DmShareds.Http.get(`./api/dm/students/new`, {params: params});
    return res.data;
  }

  static async edit_student(id: any, params: any = null) {
    const res = await DmShareds.Http.get(`./api/dm/students/${id}/edit`, {params: params});
    return res.data;
  }

  static async student(id: any, params: any = null) {
    const res = await DmShareds.Http.get(`./api/dm/students/${id}`, {params: params});
    return res.data;
  }
}
